<template>
  <div class="number-pad-container">
    <h3 class="phone-number-prompt">Enter Phone Number</h3>
    <div class="phone-display">{{ phoneNumber }}</div>
    <div class="number-pad">
      <button
        v-for="key in keys"
        :key="key"
        class="number-key"
        @click="onKeyPress(key)"
      >
        {{ key }}
      </button>
    </div>
    <div class="bottom-row">
      <button class="clear-button" @click="clear">
        <i v-if="isSmallScreen" class="fas fa-delete-left"></i>
        <span v-else>Clear</span>
      </button>
      <button class="zero-button" @click="onKeyPress('0')">0</button>
      <button class="submit-button" @click="submitPhoneNumber">
        <i v-if="isSmallScreen" class="fas fa-check"></i>
        <span v-else>Enter</span>
      </button>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import APIService from "@/service/APIService";

export default {
  props: {
    initialPhoneNumber: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      phoneNumber: this.initialPhoneNumber,
      keys: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      isSmallScreen: false,
      status: "re_phone_no",
    };
  },
  mounted() {
    this.checkButtonWidth();
    window.addEventListener("resize", this.checkButtonWidth);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkButtonWidth);
  },
  methods: {
    onKeyPress(key) {
      if (this.phoneNumber.length < 15) {
        this.phoneNumber += key;
      }
    },
    clear() {
      this.phoneNumber = "";
    },
    submitPhoneNumber() {
      if (this.phoneNumber) {
        this.$emit("phone-number-added", this.phoneNumber);
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("token");
        new APIService(
          token,
          this.apiBaseURL,
          "customer-display/client/submit-phone-number"
        )
          .postData({ phone_number: this.phoneNumber })
          .then((response) => {
            if (response.status === 200) {
              this.$emit("update-status", "billing");
            }
          });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter a phone number.",
          confirmButtonText: "OK",
          background: "#f8f9fa",
          iconColor: "#dc3545",
          confirmButtonColor: "#dc3545",
        });
      }
    },
    checkButtonWidth() {
      const numberPadButton = this.$el.querySelector(".number-key");
      const clearButton = this.$el.querySelector(".clear-button");
      const submitButton = this.$el.querySelector(".submit-button");

      if (numberPadButton && clearButton && submitButton) {
        const numberPadButtonWidth = numberPadButton.offsetWidth;
        const clearButtonWidth = clearButton.offsetWidth;
        const submitButtonWidth = submitButton.offsetWidth;

        this.isSmallScreen =
          clearButtonWidth > numberPadButtonWidth ||
          submitButtonWidth > numberPadButtonWidth;
      }
    },
  },
};
</script>

<style scoped>
.number-pad-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: linear-gradient(to bottom, #033d8c, #0598d1);
  padding: 10px;
  box-sizing: border-box;
}

.phone-number-prompt {
  font-size: 3rem;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.6);
  margin-bottom: 20px;
  text-align: center;
  font-family: "Poppins", sans-serif;
}

.phone-display {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 20px;
  width: 80%;
  text-align: center;
  background: white;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
}

.number-pad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  width: 80%;
  margin-bottom: 20px;
}

.number-key {
  font-size: 2.5rem;
  font-weight: bold;
  color: #ffffff;
  background-color: #033d8c;
  border: none;
  border-radius: 10px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.number-key:hover {
  background-color: #0598d1;
  transform: scale(1.05);
}

.bottom-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  width: 80%;
}

.clear-button,
.zero-button,
.submit-button {
  font-size: 2.5rem;
  font-weight: bold;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.clear-button {
  background-color: #ff4d4d;
}

.clear-button:hover {
  background-color: #e04343;
}

.zero-button {
  background-color: #033d8c;
}

.zero-button:hover {
  background-color: #0598d1;
}

.submit-button {
  background-color: #4caf50;
}

.submit-button:hover {
  background-color: #45a049;
}

/* Adjust icon size for small screens */
@media (max-width: 600px) {
  .clear-button i,
  .submit-button i {
    font-size: 3rem; /* Icon size */
  }

  .clear-button span,
  .submit-button span {
    display: none; /* Hide text on small screens */
  }
}
</style>
